/// <reference types="vite/client" />
import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, HeadContent, Outlet, Scripts } from '@tanstack/react-router'
import * as React from 'react'

import { DefaultCatchBoundary } from '@/components/DefaultCatchBoundary'
import { NotFound } from '@/components/NotFound'
import { queryClient } from '@/data/queryClient'
import { seo } from '@/lib/seo'

import appCss from './app.css?url'

export const Route = createRootRoute({
	head: () => ({
		meta: [
			{ charSet: 'utf-8' },
			{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
			...seo({
				title: 'Їдло | Бургерна, шаурма, десерти',
				description: `Смачні бургери та лаваш-роли, з собою та доставка.`,
			}),
		],
		links: [
			{ rel: 'stylesheet', href: appCss },
			{
				rel: 'apple-touch-icon',
				sizes: '180x180',
				href: '/apple-touch-icon.png',
			},
			{ rel: 'icon', type: 'image/png', href: '/favicon.png' },
		],
		scripts: import.meta.env.PROD
			? [
					{
						src: 'https://analytics.fedir.net/script.js',
						defer: true,
						'data-website-id': '16527eb2-c3f7-4856-aaa1-9fb6c0f93010',
						type: 'text/javascript',
					},
					{ src: 'https://www.googletagmanager.com/gtag/js?id=G-FDLZNPEXYJ', async: true },
					{
						dangerouslySetInnerHTML: {
							__html: ` 
						  window.dataLayer = window.dataLayer || []; 
						  function gtag(){dataLayer.push(arguments);} 
						  gtag('js', new Date()); 
						
						  gtag('config', 'G-FDLZNPEXYJ'); 
						`,
						},
					},
				]
			: undefined,
	}),
	errorComponent: DefaultCatchBoundary,
	notFoundComponent: () => <NotFound />,
	component: RootComponent,
	ssr: true,
})

function RootComponent() {
	return (
		<RootDocument>
			<Outlet />
		</RootDocument>
	)
}

function RootDocument({ children }: { children: React.ReactNode }) {
	return (
		<html>
			<head>
				<HeadContent />
			</head>
			<body>
				<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>

				<Scripts />
			</body>
		</html>
	)
}
